import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import {
  AppsSharedModule,
  BaseAdministrationModule,
  BaseCandidatesModule,
  BaseFormsModule,
  BaseSharedModule,
  baseTranslateLoaderFactory,
  BaseUsersModule,
} from 'base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WrapperComponent } from './_components/wrapper/wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    BaseSharedModule,
    BaseCandidatesModule,
    BaseAdministrationModule,
    BaseFormsModule,
    AppsSharedModule,
    NgbModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: baseTranslateLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'de',
    }),
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    CommonModule,
    BaseSharedModule,
    BaseCandidatesModule,
    BaseUsersModule,
    BaseAdministrationModule,
    TranslateModule,
    ReactiveFormsModule,
    NgbModule,
    FormsModule,
  ],
  declarations: [WrapperComponent],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [DatePipe],
    };
  }
}
